import { IBusinessConfigs } from '../_Common/Const/BusinessConfigs';
import { initConst } from '../../../Utils/utils';

const KJBusinessConfig = initConst<IBusinessConfigs>(() => ({
  KJKremation: {
    defaultColumns: [
      { attributeDef: 'NR', caption: 'Nr' },
      { attributeDef: 'Avliden.OrgNrPersNr', caption: 'Personnr' },
      { attributeDef: 'FOSTERNUMMER', caption: 'Nr (Personnr saknas)' },
      { attributeDef: 'Namn', caption: 'Namn' },
      { attributeDef: 'DODSDATUM', caption: 'Dödsdat' },
      { attributeDef: 'GRAVSDATUM', caption: 'Gravs dat' },
      { attributeDef: 'BEGRAVDAT', caption: 'Begr.dat' },
      { attributeDef: 'AVHAMTDATUM', caption: 'Avh.dat' },
      { attributeDef: 'AVHAMTARE', caption: 'Avhämtare' },
      { attributeDef: 'Avliden.LKF', caption: 'LKF' },
      { attributeDef: 'INTYGSDATUM', caption: 'Int.dat' },
      { attributeDef: 'BEGRAVTID', caption: 'Begr.tid' },
      { attributeDef: 'BEGRPLATS', caption: 'Begr.plats' },
      { attributeDef: 'Anhorig.Namn', caption: 'Anhörig' },
      { attributeDef: 'Krematorium.BENAMNING', caption: 'Krematorium' },
      { attributeDef: 'KREMDATUM', caption: 'Kremationsdat' },
      { attributeDef: 'TVIST', caption: 'Tvist föreligger' },
    ],
  },
  KJKrematorium: {
    defaultColumns: [
      { attributeDef: 'KREMATORIUM', caption: 'Krematorium' },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
    ],
  },
  KJRapportlayout: {
    defaultColumns: [{ attributeDef: 'LAYOUT', caption: 'Layout' }],
  },
  KJKremList: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'TypBen', caption: 'Typ' },
    ],
  },
}));

export default KJBusinessConfig;
